import { publishAlertNotification } from '@nbx/frontend-helpers/publish';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import NBXUsers from 'services/users.service';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

const NOTIFICATION_TIMEOUT_MS = 1000;

export const MarketAlertsToggle = ({ pair }) => {
  const [loading, setLoading] = useState(true);
  const [enabled, setEnabled] = useState(false);
  const { t } = useTranslation();
  const status = useCallback(isEnabled => t(`market_alerts_${isEnabled ? 'enabled' : 'disabled'}`), [t]);

  useEffect(() => {
    NBXUsers.getMarketAlerts(pair)
      .then(({ priceVolatility }) => setEnabled(priceVolatility.enabled))
      .finally(() => setLoading(false));
  }, [pair]);

  const toggle = useCallback(
    event => {
      event.stopPropagation();
      NBXUsers.patchMarketAlerts(pair, !enabled).then(() => {
        publishAlertNotification(status(!enabled), NOTIFICATION_TIMEOUT_MS);
        setEnabled(!enabled);
      });
    },
    [enabled, status]
  );
  const icon = enabled ? 'bell-alert' : 'bell-slash';
  return (
    <div className={styles.wrapper}>
      {!loading && <nbx-icon icon={icon} size="18" onClick={toggle} tooltip={status(enabled)} />}
    </div>
  );
};

MarketAlertsToggle.propTypes = {
  pair: PropTypes.string.isRequired
};
